import { Config } from '../../_config'
import { UseCase } from '../../_kernel/architecture'
import { LoginStatus } from '../domain/LoginStatus'
import { AuthRepository } from '../domain/AuthRepository'
import { CookieAuthRepository } from '../infrastructure/CookieAuthRepository'

export default class GetCurrentLoginStatusAuthUseCase implements UseCase<undefined, LoginStatus> {
  static readonly USE_CASE_NAME = 'GetCurrentLoginStatusAuthUseCase'
  static create({ config, repository }: { config: Config; repository?: AuthRepository }) {
    return new GetCurrentLoginStatusAuthUseCase(
      config,
      repository ?? CookieAuthRepository.create({ config })
    )
  }

  constructor(
    private readonly config: Config,
    private readonly repository: AuthRepository
  ) {}

  async execute() {
    return this.repository.checkLoginStatus()
  }
}
